var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row px-3" },
    [
      _c("div", { staticClass: "col-12 px-0 icon-and-title" }, [
        _c(
          "div",
          {
            staticClass: "wrap-icon",
            class: { "error-input": _vm.$v.page.selectedIcon.$error },
            on: { click: _vm.showModalIcon }
          },
          [
            _vm.page.selectedIcon
              ? _c("img", {
                  staticClass: "page-icon",
                  attrs: { src: _vm.page.selectedIcon.icon_grey }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("p", [_vm._v("Change")]),
            _vm._v(" "),
            _vm.$v.page.selectedIcon.$error
              ? _c("div", { staticClass: "error-icon" }, [
                  _vm._v("\n        Please select icon for this menu\n      ")
                ])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.page.titlePage,
              expression: "page.titlePage"
            }
          ],
          class: { "error-input": _vm.$v.page.titlePage.$error },
          attrs: { type: "text", placeholder: "Type Title Page" },
          domProps: { value: _vm.page.titlePage },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.page, "titlePage", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.isPopover ? "col-12 p-0" : "col-6 pl-0 pr-1" }, [
        _c(
          "div",
          {
            staticClass: "wrap-config",
            class: { "error-input": _vm.$v.page.selectedType.$error }
          },
          [
            _c("p", { staticClass: "config-header" }, [_vm._v("Type")]),
            _vm._v(" "),
            _c("p", { staticClass: "config-description" }, [
              _vm._v("\n        Type of menu for this page\n      ")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex align-items-center mt-2" },
              _vm._l(_vm.listTypeOptions, function(option) {
                return _c(
                  "div",
                  {
                    key: option.id,
                    staticClass: "btn-option",
                    class: {
                      active: _vm.page.selectedType === option.id,
                      disabled: _vm.page.selectedType && _vm.mode === "edit"
                    },
                    on: {
                      click: function($event) {
                        _vm.page.selectedType = option.id
                      }
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(option.text))])]
                )
              })
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.isPopover ? "col-12 p-0" : "col-6 pr-0 pl-1" }, [
        _c(
          "div",
          {
            staticClass: "wrap-config",
            class: { "error-input": _vm.$v.page.displayMode.$error }
          },
          [
            _c("p", { staticClass: "config-header" }, [_vm._v("Display Mode")]),
            _vm._v(" "),
            _c("p", { staticClass: "config-description" }, [
              _vm._v(
                "\n        The visibility of screen on the device.\n      "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex align-items-center mt-2" },
              _vm._l(_vm.listDisplayOptions, function(option) {
                return _c(
                  "div",
                  {
                    key: option.id,
                    staticClass: "btn-option",
                    class: {
                      active: _vm.displayModeSelected.includes(option.id)
                    },
                    on: {
                      click: function($event) {
                        _vm.handleDisplayMode(option.id)
                      }
                    }
                  },
                  [
                    !_vm.displayModeSelected.includes(option.id)
                      ? _c("div", { staticClass: "circle-checkbox" })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.displayModeSelected.includes(option.id)
                      ? _c("img", {
                          staticClass: "checked",
                          attrs: {
                            src: require("@/assets/new-form-ui/icon-active/check-circle-active.svg")
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "icon-btn",
                      attrs: {
                        src: require("@/assets/form-ui/" +
                          option.id +
                          (_vm.displayModeSelected.includes(option.id)
                            ? "-active"
                            : "") +
                          ".svg")
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(option.text))])
                  ]
                )
              })
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm.useModalIcon
        ? _c("j-modal-page-icon", {
            attrs: { id: _vm.idModalIcon, "icon-options": _vm.iconOptions },
            on: {
              "select-icon": _vm.setPageIcon,
              "close-modal": _vm.closeModalIcon
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f8fb554", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f8fb554","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/setting/jFormPage.vue
// module id = null
// module chunks = 